import { EntityList } from '@avangard/utils/entity';

import { OnlineStudentPerformanceItemEntity } from './online-student-performance-item.entity';

import type { Entity } from './online-student-performance-item.entity';

class OnlineStudentPerformanceItemEntityList extends EntityList<OnlineStudentPerformanceItemEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(OnlineStudentPerformanceItemEntity, items, count);
    }
}

export { OnlineStudentPerformanceItemEntityList };
